import { useRFSInvalids } from "@/api/rfs";
import { CheckSquare2, SquareX } from "lucide-react";

export function RFSInvalidTable({ rfsId }: { rfsId: string }) {
  const { data: rfsInvalids } = useRFSInvalids({
    rfsId: rfsId,
  });

  const keyMapping: { [key: string]: string } = {
    clusterId: "ClusterID",
    pole: "Pole",
    fdtId: "FDTID",
    fatId: "FATID",
    cableDistribution: "CABLE DISTRIBUTION",
    cableDrop: "CABLE DROP",
    folderStructureAndSequence: "Struktur/Urutan Folder",
    subFolder: "Sub Folder",
    folderName: "Foldername",
    symbol: "Symbol",
    requiredFolder: "REQUIRED FOLDER",
    homepass: "Homepass",
  };

  const formatKey = (key: string | null) => {
    if (!key) return "-";
    return keyMapping[key] || key;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full table-auto border-collapse">
        <thead>
          <tr>
            <th className="p-4 text-left text-sm font-medium">No</th>
            <th className="p-4 text-left text-sm font-medium">Description</th>
            <th className="p-4 text-left text-sm font-medium">
              Validation Result
            </th>
          </tr>
        </thead>
        <tbody>
          {rfsInvalids?.map((rfsInvalid, index: number) => (
            <tr key={rfsInvalid.id} className="border-y">
              <td className="p-4 text-left text-sm">{index + 1}</td>
              <td className="p-4 text-left text-sm">
                {rfsInvalid.key ? formatKey(rfsInvalid.key) : "-"}
              </td>
              <td className="flex justify-center p-4 text-sm">
                {rfsInvalid.valid ? (
                  <CheckSquare2 color="#5dee7a" />
                ) : (
                  <SquareX color="#f44336" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
